<script>
  import { dndzone } from 'svelte-dnd-action'
  import { flip } from 'svelte/animate'
  import ImageUploadDrawer from './image_upload_drawer.svelte'
  import ImageLibraryDrawer from './image_library_drawer.svelte'
  import ClickableImage from './lightbox/clickable_image.svelte'
  import { Button } from './ui'

  // Form-field-style gallery: bindable value is an ordered array of { id, title, url }.
  // Combines image_upload_drawer + image_library_drawer + drag-reorder in one control.
  let { value = $bindable([]), label, multiple = true, placeId } = $props()

  let uploadOpen = $state(false)
  let libraryOpen = $state(false)

  const remove = (id) => {
    value = value.filter((image) => image.id !== id)
  }

  // No dedupe needed: the library marks attached images (clicking one removes it) and an
  // upload is always a new image.
  const add = (images) => {
    value = multiple ? [...value, ...images] : images.slice(0, 1)
  }

  const handleFinalize = (event) => {
    value = event.detail.items
  }
</script>

<fieldset class="fieldset">
  {#if label}<legend class="fieldset-legend">{label}</legend>{/if}

  {#if value.length > 0}
    <div
      class="grid grid-cols-4 gap-2 mb-2"
      use:dndzone={{ items: value, dragDisabled: value.length < 2, flipDurationMs: 150, dropTargetStyle: {} }}
      onconsider={(event) => (value = event.detail.items)}
      onfinalize={handleFinalize}
    >
      {#each value as image (image.id)}
        <div class="relative group" animate:flip={{ duration: 150 }}>
          <ClickableImage url={image.url} title={image.title || ''} thumbClass="aspect-square w-full object-contain bg-base-200 rounded-box" buttonClass="w-full" />
          <Button
            variant="error"
            size="xs"
            circle
            icon="close"
            aria-label="Remove image"
            class="absolute -top-2 -right-2"
            onclick={() => remove(image.id)}
          />
        </div>
      {/each}
    </div>
  {/if}

  <div class="flex gap-2">
    <Button variant="default" size="sm" onclick={() => (libraryOpen = true)}>Choose from library</Button>
    <Button variant="default" size="sm" onclick={() => (uploadOpen = true)}>Upload new</Button>
  </div>
</fieldset>

<ImageLibraryDrawer
  bind:open={libraryOpen}
  {multiple}
  {placeId}
  attachedIds={value.map((image) => image.id)}
  onselect={add}
  onremove={(image) => remove(image.id)}
/>
<ImageUploadDrawer bind:open={uploadOpen} {placeId} onuploaded={(image) => add([image])} />
